module.exports = __webpack_public_path__ + "static/media/customer015.860be05e.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/img/customer015.png
// module id = 862
// module chunks = 0